import { Link } from "react-router-dom";
import Container from "../Container";
import Title from "../Title";
import classes from "./index.module.scss";
import webp from "../images/university.webp";
import png from "../images/university.png";
import btnClasses from "../../../components/commons/Button.module.scss";

export default function University() {
  return (
    <section>
      <Container>
        <div className={classes.body}>
          <div className={classes.content}>
            <Title>Our University</Title>
            <div className={classes.text}>
              <p>
                If you want to upgrade your skills or even learn something from
                scratch, then welcome to our Engenious online university. Here,
                the best experts will explain the material to you in an
                easy-to-understand way using real-life examples.
              </p>
              <p>
                Graduates of our online university are already working for
                Amazon, Apple, Google, Nest, and Fitbit.{" "}
              </p>
            </div>

            <Link
              data-content="see more"
              className={`${btnClasses.button}`}
              to="/university"
            >
              see more
            </Link>
            <div className={classes.image}>
              <picture>
                <source srcSet={webp} type="image/webp" />
                <img src={png} alt="University" width={984} height={597} />
              </picture>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
